'use es6';

import { createSelector } from '@reduxjs/toolkit';
import getMeetingsLinkUrl from 'conversations-internal-schema/responders/operators/getMeetingsLinkUrl';
import { getAssignedResponderInWidget } from '../../responders/selectors/getAssignedResponderInWidget';
export const shouldShowMeetingsLink = createSelector([getAssignedResponderInWidget], assignedResponder => Boolean(assignedResponder && getMeetingsLinkUrl(assignedResponder)));